import React, { useState } from "react";
import { TextInput, TextArea, useForm } from "../../Components/Inputs";
import init_po from "../init_po";
import Btn from "../../../../Components/Buttons/Btn";
import { useNavigate } from "react-router-dom";
import useAxios from "../../../../Hooks/useAxios";
import useApp from "../../../../Hooks/useApp";

const Add = () => {
  const [input, setInput] = useState(init_po);
  const navigate = useNavigate();
  const request = useAxios();
  const { user } = useApp();

  const handleSubmit = async (data) => {
    const quantity = parseInt(data.quantity.replace(/,/g, ""));
    const total_cost = parseFloat(data.total_amount.replace(/,/g, ""));

    const payload = {
      item_name: data.item_name,
      quantity,
      total_cost,
      cost_per_item: total_cost / quantity,
      description: data.description,
      created_by: parseInt(user?.id),
    };

    const res = await request({
      method: "POST",
      url: "purchase-orders/add",
      body: payload,
    });

    if (res !== "error") {
      navigate("/dashboard/purchase-orders");
    }
  };

  const { handleValidation, validate } = useForm({
    input,
    submit: handleSubmit,
  });

  return (
    <div className="border-t shadow-2xl w-[85%] m-auto mt-12 p-5 rounded-md">
      <h3 className="text-center text-xl font-semibold text-primary">
        Add Purchase Order
      </h3>
      <div className="mt-5">
        <TextInput input={input} setInput={setInput} field="item_name" />
        <div className="flex gap-5 max-md:flex-col max-md:w-full">
          <TextInput input={input} setInput={setInput} field="quantity" />
          <TextInput input={input} setInput={setInput} field="total_amount" />
        </div>
        <TextArea input={input} setInput={setInput} field="description" />
      </div>
      <div className="mt-5 flex justify-between">
        <Btn
          onClick={() => navigate("/dashboard/purchase-orders")}
          variant="secondary"
        >
          Back
        </Btn>
        <Btn onClick={handleValidation}>Submit</Btn>
      </div>
    </div>
  );
};

export default Add;
